import React from 'react'
import { Tabs } from 'antd'
import PageLayout from '@layouts/PageLayout'
import { useLocalization } from '@contexts/LocalizationContext'
import MaleTab from './MaleTab'
import FemaleTab from './FemaleTab'

// const { TabPane } = Tabs

const List = () => {
  // const fetchRef = useRef(null)
  const { t } = useLocalization()
  const items = [
    {
      label: t('height.listScreen.tabs.male'),
      key: '1',
      children: <MaleTab />,
    },
    {
      label: t('height.listScreen.tabs.female'),
      key: '2',
      children: <FemaleTab />,
    },
  ]

  return (
    <PageLayout title={t('height.listScreen.title')} shownBack={false}>
      <Tabs defaultActiveKey="1" items={items} />
    </PageLayout>
  )
}

export default List
